module.exports = __webpack_public_path__ + "img/no_image.53957753.jpg";